import { Box } from '@mui/material';

import { NOTCHED_OUTLINE_CLASS_NAME } from '../constants';
import { NOTCHED_FIELDSET_LEGEND_SX, NOTCHED_FIELDSET_SX } from '../styles';

import type { NotchedFieldsetProps } from '../types';

export default function NotchedFieldset({ label }: NotchedFieldsetProps) {
  return (
    <Box aria-hidden className={NOTCHED_OUTLINE_CLASS_NAME} component="fieldset" sx={NOTCHED_FIELDSET_SX}>
      <Box component="legend" sx={NOTCHED_FIELDSET_LEGEND_SX}>
        <span>{label != null && label !== '' ? label : '\u200B'}</span>
      </Box>
    </Box>
  );
}
